import React, { useEffect, useState } from 'react';
import "./Dashboard.css";
import { useNavigate, useLocation, NavLink, Route, Routes } from 'react-router-dom';
import { UiChecks, PersonVcardFill, DatabaseFillGear } from 'react-bootstrap-icons';

const Dashboard = (props) => {
    return (
            <div id="benvinda">
               {props.token["usuario"]["apelido"]}
            </div>
    );
}

export default Dashboard;